import React, { useState } from 'react';
import '../styles/CTA.css';

const CTA = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('¡Gracias por su interés! Nos pondremos en contacto pronto.');
    setEmail('');
  };

  return (
    <section className="cta-section" id="contacto">
      <div className="cta-content">
        <h2>¿Listo para transformar sus espacios?</h2>
        <p>
          Solicite una cotización gratuita y descubra cómo podemos ayudarle a mantener 
          ambientes limpios, saludables y sostenibles.
        </p>
        <form className="cta-form" onSubmit={handleSubmit}>
          <input 
            type="email" 
            className="cta-input" 
            placeholder="Su correo electrónico" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required 
          />
          <button type="submit" className="cta-submit">
            Solicitar Cotización
          </button>
        </form>
      </div>
    </section>
  );
};

export default CTA;
